export const FB_PIXEL_ID = '1206649947083902';

// Initialize Meta Pixel
export const initializePixel = () => {
  if (typeof window === 'undefined') return;

  window.fbq = function () {
    if (window.fbq.callMethod) {
      window.fbq.callMethod.apply(window.fbq, arguments);
    } else {
      window.fbq.queue.push(arguments);
    }
  };

  if (!window._fbq) window._fbq = window.fbq;
  window.fbq.push = window.fbq;
  window.fbq.loaded = true;
  window.fbq.version = '2.0';
  window.fbq.queue = [];
  window.fbq('init', FB_PIXEL_ID);
  window.fbq('track', 'PageView');
};

// Track page views
export const pageView = () => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'PageView');
  }
};

// Track standard events
export const event = (eventName, options = {}) => {
  console.log(`Tracking ${eventName} event:`, options);
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', eventName, options);
  }
};

// Track custom events
export const trackCustomEvent = (name, options = {}) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('trackCustom', name, options);
  }
};

// Lead event
export const trackLead = (options = {}) => {
  console.log('Tracking lead event:', options);
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'Lead', {
      content_name: options.content_name || 'Lead',
      status: options.status || 'unknown',
      ...options
    });
  }
};

// ViewContent event
export const trackViewContent = (options = {}) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'ViewContent', options);
  }
};

// AddToCart event
export const trackAddToCart = (options = {}) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart', options);
  }
};

// InitiateCheckout event
export const trackInitiateCheckout = (options = {}) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'InitiateCheckout', options);
  }
};
